import * as Sentry from '@sentry/browser';
import jsCookie from 'js-cookie';

export const utmGlobalKey = 'utm_global_id';
export const utmTrackingKey = 'utm_tracking_id';

function getUtmIds() {
  let ret = {};
  ret.utm_global_id = jsCookie.get(utmGlobalKey);
  ret.utm_tracking_id = jsCookie.get(utmTrackingKey);
  return ret;
}

const sentryError = (err, extra = {}, tags) => {
  try {
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      applyExtra(scope, extra);
      applyTags(scope, tags);
      Sentry.captureException(err);
    });
  } catch (e) {
    Sentry.captureException(err);
  }
};

const sentryWarning = (err, extra = {}, tags) => {
  try {
    Sentry.withScope((scope) => {
      scope.setLevel('warning');
      applyExtra(scope, extra);
      applyTags(scope, tags);
      Sentry.captureException(err);
    });
  } catch (e) {
    Sentry.captureException(err);
  }
};

const sentryInfo = (err, extra = {}, tags) => {
  try {
    Sentry.withScope((scope) => {
      scope.setLevel('info');
      applyExtra(scope, extra);
      applyTags(scope, tags);
      Sentry.captureException(err);
    });
  } catch (e) {
    Sentry.captureException(err);
  }
};

const applyTags = (scope, tags) => {
  tags && Object.keys(tags).forEach((key) => {
    scope.setTag(key, tags[key]);
  });
};

const applyExtra = (scope, extra) => {
  addUtmIdExtras(extra);
  extra && Object.keys(extra).forEach((key) => {
    scope.setExtra(key, extra[key]);
  });
};

const addUtmIdExtras = (extra) => {
  Object.assign(extra, getUtmIds());
};

export {
  sentryError,
  sentryWarning,
  sentryInfo,
};
